export const ROUND_FADE_TIME:number = 2000
export const ROUND_FADE_INCREMENT:number =100